const API_BASE_URL = process.env.VUE_APP_API_URL;

const createEndpoint = (path) => `${API_BASE_URL}${path}`;

const API_PATHS = {
    LOGIN: '/employees/login',
    LOGIN_ADMIN: '/employees/admin/login',
    DEPARTMENTS: '/departments',
    MANAGEMENT_CONTACTS: '/management-contacts',
    EMPLOYEE_BIRTHDAYS: '/employees/birthdays',
    EMPLOYEE_POSITIONS: '/positions-employee',
    EMPLOYEE_DUTIES: '/employee-duties',
    VACATION_DAYS: '/vacation-days/external',
    DEBTS_ANY: '/debts-any',
    DEBTS_EXPEDITORS: '/debts-expeditors',
    DEBTS_DOCS: '/debts-docs',
    WORK_SCHEDULE: '/brigade-schedules/employee',
    LEADERS: '/leaders',
    EMPLOYEE: '/employees',
    VACANCIES: '/vacancies',
    WORK_REST_SETTINGS: '/work-rest-settings',
    PROFITABILITY: '/profitability',
    DINING_MENU: '/dining-menus',
    BRIGADE_SCHEDULES: '/brigade-schedules',
    SET_PIN: '/employees/set-password',
    CHECK_PIN: '/employees/check-password',
    RESET_PIN: '/employees',
    PIECEWORK: '/piecework',
    STOCKS: '/stocks',
    STOCKS_ADMIN: '/stocks/admin',
    STATS_DASHBOARD: '/stats/dashboard',
    STATS_VISITS: '/stats/visits',
};

export const API_ENDPOINTS = Object.freeze(
    Object.entries(API_PATHS).reduce((acc, [key, path]) => ({
        ...acc,
        [key]: createEndpoint(path),
    }), {}),
);
